module.exports = __webpack_public_path__ + "static/media/frontpage.30442bc9.png";